// Compat shim: ported hooks/components import { createSupabaseBrowser } from
// '@/lib/supabase/client'. Return the shared singleton.
import { supabase } from '@/lib/supabase';

export function createSupabaseBrowser() {
	return supabase;
}
